import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

interface IStylesProps {
  isPreview?: boolean;
}

export default makeStyles<MuiTheme, IStylesProps>(() => ({
  circle: {
    fill: "transparent"
  },
  circleOutline: {
    fill: "transparent"
  },
  barnPath: {
    fill: "#d7d9d1"
  },
  cls0: {
    fill: "#EBF3D6"
  },
  cls1: {
    fill: "#C2E8FA"
  },
  cls2: {
    fill: "#D0E6B5"
  },
  cls3: {
    fill: "#F6EFDD"
  },
  cls4: {
    fill: "#DCECC8"
  },
  cls5: {
    fill: "#FAFBF0"
  },
  cls6: {
    fill: "#FFFFFF"
  },
  cls7: {
    fill: "#D7D9D1"
  },
  cls8: {
    fill: "#8D908C"
  },
  cls9: {
    fill: "#6C6C6C"
  },
  cls10: {
    fill: "#808285"
  },
  cls11: {
    fill: "#6BC285"
  },
  cls12: {
    fill: "#F3F5EA"
  },
  cls13: {
    fill: "#009444"
  },
  cls14: {
    fill: "none"
  },
  hasHorses: {
    cursor: ({ isPreview }) => (isPreview ? "default" : "pointer"),
    "& $barnPath": {
      fill: "#6bc285"
    },
    "& $circle": {
      fill: "#f3f5ea"
    },
    "& $circleOutline": {
      fill: "#009444"
    }
  }
}));
